import {IntermediatePageDefaultBox} from './intermediate-page.default.box';

export const IntermediatePageBox = IntermediatePageDefaultBox;